import { render, staticRenderFns } from "./CompanyHistoryPage.vue?vue&type=template&id=627492a9&scoped=true&"
import script from "./CompanyHistoryPage.vue?vue&type=script&lang=js&"
export * from "./CompanyHistoryPage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHistoryPage.vue?vue&type=style&index=0&id=627492a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627492a9",
  null
  
)

export default component.exports